import Dexie from 'dexie'
import { IEvent } from '../../models/Event'
import { IRoom } from '../../models/Room'

type Events = IEvent & IUserData
type Rooms = IRoom & IWithColor & IUserData

class BedBookingDatabase extends Dexie {
  public events!: Dexie.Table<Events & IWithColor, string>
  public rooms!: Dexie.Table<Rooms, string>

  public constructor(mobile: boolean) {
    super('BedBooking')

    if (!mobile) {
      this.version(6).stores({
        events:
          '++id,roomId,startDate,finishDate,calendarId,userId,[calendarId+startDate],[calendarId+finishDate]',
        rooms: '++id,name,roomSize,calendarId',
      })

      this.events = this.table('events')
      this.rooms = this.table('rooms')
    } else {
      // In mobile mode, create dummy objects with the necessary methods
      this.events = new Proxy({}, {
        get(target, prop) {
          return async () => {}
        }
      }) as Dexie.Table<Events & IWithColor, string>

      this.rooms = new Proxy({}, {
        get(target, prop) {
          return async () => {}
        }
      }) as Dexie.Table<Rooms, string>
    }
  }
}

const db = new BedBookingDatabase(window.location.search.includes('mobile=1') && window.location.pathname.includes('statistics/overview'))

export default db

export interface IWithColor {
  savedColor?: string
}

export interface IUserData {
  calendarId: number
}